import ApiRequestor from "../../../api_access/ApiRequestor";
import {Dispatch} from "redux"
import { GetABMCONSULTADispatchTypes, GET_ABMCONSULTA_LOADING, GET_ABMCONSULTA_SUCCESS, GET_ABMCONSULTA_FAIL } from './ABMConsultaActionsTypes';


export const GetABMConsulta = () => async (dispatch: Dispatch<GetABMCONSULTADispatchTypes>) => {
    try {
        dispatch({
            type: GET_ABMCONSULTA_LOADING
        })
        const response : any = await ApiRequestor.requestToApi("/client-access", "GET", null, "USER", false);
        dispatch({
            type: GET_ABMCONSULTA_SUCCESS,
            payload: response.data
        })
    } catch(error) {
        console.log(error);
        dispatch({
            type: GET_ABMCONSULTA_FAIL
        })
    }
   
}